import * as tooltips from "./tooltips";
import * as markers from "./markers";
import GeoJSONPointsCollection from "../../../../components/maps/GeoJSONMap/GeoJSONPointsCollection";
import React, {useCallback} from "react";


const IncidentsLayer = ({webgis}) => {
    const {layersState, featuresState} = webgis;
    const {
        incidentsGeoJSON,
        incidentSelectedState,
        webgisRegistryQuery,
        contrastColorsHash
    } = featuresState;
    const {layers} = layersState;

    const registry = webgisRegistryQuery.data ?? {};
    const layerRegistry = registry["incidents"];
    const incidentRegistry = featuresState.incidentRegistryQuery.data ?? {};

    const incidentMarkerIconFn = (feature) => {
        const param = layers.incidents.visibleParam;
        const value = feature.properties?.[param];
        const colorCode = markers.getColorForValue(value, param, layerRegistry);
        const textColor = contrastColorsHash[colorCode] ?? '#ffffff';

        const isSelected = incidentSelectedState.getSelectedFeatures().some(f => f.id === feature.id);

        return markers.incidentMarker({feature, colorCode, isSelected, textColor});
    }

    const incidentClusterIconFn = (cluster) => {
        const param = layers.incidents.visibleParam;
        
        // For simplicity, we take the max value among the clustered incidents to determine the cluster color
        let maxValue = null;
        cluster.getAllChildMarkers().forEach(marker => {
            const value = marker.options.feature?.properties?.[param];
            if (value !== undefined && value !== null) {
                if (maxValue === null || value > maxValue) {
                    maxValue = value;
                }
            }
        });

        const colorCode = markers.getColorForValue(maxValue, param, layerRegistry);
        const textColor = contrastColorsHash[colorCode] ?? '#ffffff';
        return markers.incidentCluster({cluster, colorCode, textColor});
    }

    const renderFeatureTooltip = useCallback((feature) => tooltips.renderIncidentTooltip(feature, incidentRegistry), [incidentRegistry])

    const incidentsClusterGroupKey = `incidentsClusterGroup-${incidentsGeoJSON?.features?.length}-${layers.incidents.visibleParam}-${featuresState.geoIncidentsQuery.dataUpdatedAt}`;

    return <GeoJSONPointsCollection featureCollection={incidentsGeoJSON}
                                    cluster
                                    onFeatureClick={webgis.handleIncidentClick}
                                    getSelectedFeatures={incidentSelectedState.getSelectedFeatures}
                                    renderFeatureTooltip={renderFeatureTooltip}
                                    markerIconFn={incidentMarkerIconFn}
                                    clusterIconFn={incidentClusterIconFn}
                                    clusterGroupProps={{key: incidentsClusterGroupKey}}/>
}

export default IncidentsLayer;